import { render, staticRenderFns } from "./TabLeadInformation.vue?vue&type=template&id=3ad873aa"
import script from "./TabLeadInformation.vue?vue&type=script&lang=js"
export * from "./TabLeadInformation.vue?vue&type=script&lang=js"
import style0 from "./TabLeadInformation.vue?vue&type=style&index=0&id=3ad873aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports